var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_1843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.0293 6.96533L6.9045 13.892V18.1171L3.03383 25.0301L3.0293 6.96533Z",
    fill: "#5B57A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9082 11.3714L21.5394 9.14585L28.9709 9.13892L17.9082 15.916V11.3714Z",
    fill: "#D90751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8881 6.92453L17.9087 16.0952L14.0244 13.7085V0L17.8881 6.92453Z",
    fill: "#FAB718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9713 9.13893L21.5396 9.14587L17.8881 6.92453L14.0244 0L28.9713 9.13893Z",
    fill: "#ED6F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9087 25.0685V20.6192L14.0244 18.2778L14.0265 32L17.9087 25.0685Z",
    fill: "#63B22F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5306 22.8632L6.90423 13.892L3.0293 6.96533L28.9554 22.8541L21.5306 22.8632Z",
    fill: "#1487C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0264 32.0001L17.908 25.0686L21.5301 22.8633L28.9549 22.8542L14.0264 32.0001Z",
    fill: "#017F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0332 25.0302L14.0553 18.2782L10.3497 16.0046L6.90387 18.1172L3.0332 25.0302Z",
    fill: "#984995"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_1843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.fc49dd767ebf5a72d512cd23235b55fc.svg";
export { ForwardRef as ReactComponent };